import * as React from 'react';
import { Switch, Route, BrowserRouter } from 'react-router-dom';
import { Head } from 'layout/Head/Head';
import { Login } from 'layout/Login/Login';
import { MainLayout } from 'layout/MainLayout/MainLayout';
import { KundeView } from 'views/KundeView/KundeView';
import { TerminView } from 'views/TerminView/TerminView';
import { AngebotView } from 'views/AngebotView/AngebotView';
import { ServiceView } from 'views/ServiceView/ServiceView';
import { BestellungView } from 'views/BestellungView/BestellungView';
import { AuftragView } from 'views/AuftragView/AuftragView';
import { LieferungView } from 'views/LieferungView/LieferungView';
import { RechnungView } from 'views/RechnungView/RechnungView';
import { Init } from 'layout/Init/Init';
import { useSelector } from 'react-redux';
import { lookupsLoadingFinishedSelector } from 'store/lookups/selector';
import { LagerView } from 'views/LagerView/LagerView';
import { LagerstandPrint } from 'reports/lagerstand/LagerstandPrint';
import { ReportView } from 'views/ReportView/ReportView';
import { AngebotsuebersichtPrint } from 'reports/angebotsuebersicht/AngebotsuebersichtPrint';
import { AuftragsuebersichtPrint } from 'reports/auftragsuebersicht/AuftragsuebersichtPrint';
import { BetreuerabrechnungPrint } from 'reports/betreuerabrechnung/BetreuerabrechnungPrint';
import { LieferantenrechnungView } from 'views/LieferantenrechnungView/LieferantenrechnungView';
import { ExtrasView } from 'views/ExtrasView/ExtrasView';
import { ReclayZahlungPrint } from 'reports/reclayzahlung/ReclayZahlungPrint';
import { ArtikelumsatzPrint } from 'reports/artikelumsatz/ArtikelumsatzPrint';
import { ArbeitszeitPrint } from 'reports/arbeitszeit/ArbeitszeitPrint';
import { RechnungsuebersichtPrint } from 'reports/rechnungsuebersicht/RechnungsuebersichtPrint';
import { UmsatzuebersichtPrint } from 'reports/umsatzuebersicht/UmsatzuebersichtPrint';
import { RahmenauftraegePrint } from 'reports/rahmenauftraege/RahmenauftraegePrint';
import { OffeneAuftraegePrint } from 'reports/offeneauftraege/OffeneAuftraegePrint';
import { KundeSummaryPrint } from 'reports/kundesummary/KundeSummaryPrint';
import { ArbeitszeituebersichtPrint } from 'reports/arbeitszeituebersicht/ArbeitszeituebersichtPrint';
import { HochrechnungPrint } from 'reports/hochrechnung/HochrechnungPrint';
import { KarteView } from 'views/KarteView/KarteView';
import { MailingView } from 'views/ExtrasView/MailingView/MailingView';

import styles from './App.module.scss';

export const App: React.FC = () => {
    const lookupsLoadingFinished = useSelector(lookupsLoadingFinishedSelector);
    return (
        <>
            <Head title="SalesMaster" />
            <div className={styles.container}>
                <BrowserRouter>
                    <MainLayout>
                        <Switch>
                            <Route exact path="/login" component={Login} />
                            <Route exact path="/kunden" component={KundeView} />

                            <Route exact path="/lager" component={LagerView} />
                            <Route exact path="/lager/:page" component={LagerView} />
                            <Route exact path="/lager/:page/:urlRecordNr" component={LagerView} />
                            <Route exact path="/lager/:page/:urlRecordNr/:subPage" component={LagerView} />

                            <Route exact path="/kunden/:urlKundeNr" component={KundeView} />
                            <Route exact path="/kunden/:urlKundeNr/:page" component={KundeView} />
                            <Route exact path="/kunden/:urlKundeNr/:page/:urlRecordNr" component={KundeView} />

                            <Route exact path="/taetigkeiten" component={TerminView} />
                            <Route exact path="/taetigkeiten/:urlRecordNr" component={TerminView} />

                            <Route exact path="/angebote" component={AngebotView} />
                            <Route exact path="/angebote/:urlRecordNr" component={AngebotView} />

                            <Route exact path="/services" component={ServiceView} />
                            <Route exact path="/services/:urlRecordNr" component={ServiceView} />

                            <Route exact path="/auftraege" component={AuftragView} />
                            <Route exact path="/auftraege/:urlRecordNr" component={AuftragView} />

                            <Route exact path="/bestellungen" component={BestellungView} />
                            <Route exact path="/bestellungen/:urlRecordNr" component={BestellungView} />

                            <Route exact path="/lieferungen" component={LieferungView} />
                            <Route exact path="/lieferungen/:urlRecordNr" component={LieferungView} />

                            <Route exact path="/rechnungen" component={RechnungView} />
                            <Route exact path="/rechnungen/:urlRecordNr" component={RechnungView} />

                            <Route exact path="/lieferantenrechnungen" component={LieferantenrechnungView} />
                            <Route
                                exact
                                path="/lieferantenrechnungen/:urlRecordNr"
                                component={LieferantenrechnungView}
                            />

                            <Route exact path="/berichte" component={ReportView} />
                            <Route exact path="/berichte/print/lagerstand" component={LagerstandPrint} />
                            <Route
                                exact
                                path="/berichte/print/angebotsuebersicht"
                                component={AngebotsuebersichtPrint}
                            />
                            <Route
                                exact
                                path="/berichte/print/auftragsuebersicht"
                                component={AuftragsuebersichtPrint}
                            />
                            <Route
                                exact
                                path="/berichte/print/rechnungsuebersicht"
                                component={RechnungsuebersichtPrint}
                            />
                            <Route
                                exact
                                path="/berichte/print/betreuerabrechnung"
                                component={BetreuerabrechnungPrint}
                            />
                            <Route exact path="/berichte/print/reclayzahlung" component={ReclayZahlungPrint} />
                            <Route exact path="/berichte/print/artikelumsatz" component={ArtikelumsatzPrint} />
                            <Route exact path="/berichte/print/arbeitszeit" component={ArbeitszeitPrint} />
                            <Route exact path="/berichte/print/umsatzuebersicht" component={UmsatzuebersichtPrint} />
                            <Route exact path="/berichte/print/hochrechnung" component={HochrechnungPrint} />
                            <Route exact path="/berichte/print/rahmenauftraege" component={RahmenauftraegePrint} />
                            <Route exact path="/berichte/print/offeneauftraege" component={OffeneAuftraegePrint} />
                            <Route exact path="/berichte/print/kunde" component={KundeSummaryPrint} />

                            <Route
                                exact
                                path="/berichte/print/arbeitszeituebersicht"
                                component={ArbeitszeituebersichtPrint}
                            />

                            <Route exact path="/berichte/:page" component={ReportView} />

                            {/* http://localhost:3000/extras/wertetabellen/textbausteine */}

                            <Route exact path="/extras" component={ExtrasView} />

                            <Route exact path="/extras/:page/:urlRecordNr" component={ExtrasView} />
                            <Route exact path="/extras/:page" component={ExtrasView} />

                            <Route
                                exact
                                path="/extras/wertetabellen/:subPage"
                                component={ExtrasView}
                                {...{ page: 'wertetabellen' }}
                            />

                            <Route exact path="/karte" component={KarteView} />

                            <Route path="/mailing" component={MailingView} />

                            <Route path="/" component={KundeView} />
                        </Switch>
                        {lookupsLoadingFinished || <Init />}
                    </MainLayout>
                </BrowserRouter>
            </div>
        </>
    );
};
